document.addEventListener('teeinblue-event-after-cart-added', function() {
  var request = new XMLHttpRequest();

  request.open('POST', '/cart/update.js', true);
  request.setRequestHeader('Content-Type', 'application/json');
  request.onload = function() {
    if (this.status >= 200 && this.status < 400) {
      var response = JSON.parse(this.response);

      T4SThemeSP.Cart.renderContents(response.sections)
    }
  };
  request.send(JSON.stringify({
      sections: 'cart_data,mini_cart',
      sections_url: window.location.pathname,
  }));
});

document.addEventListener('teeinblue-event-component-injected', function() {

    const teeRadioInputs = document.querySelectorAll('.tee-option .tee-radio input[type="radio"]');
    teeRadioInputs.forEach(input => {
      input.addEventListener('click', function () {
        const selectedValue = this.value;
        const swatchItems = document.querySelectorAll('.t4s-swatch__list .t4s-swatch__item');
        swatchItems.forEach(item => {
          if (item.getAttribute('data-value') === selectedValue) {
            item.click();
          }
        });
      });
    });
  
});